<template>
    <!-- 设备转化率模块 -->
    <div id="realtime_udidconversion" >
        <div class="data-panel" style="margin:0">
            <div class="data-panel-header">
                <h2>{{title}}</h2>
                <div class="extra">
                    <a-select style="width:174px;" v-model="app_channel">
                        <a-select-option value="-127">{{$t("fixed.realtime.conversion.allChannel")}}</a-select-option>
                        <a-select-option :value="channel.id" v-for="channel in app_channels" :key="channel.id">{{channel.name}}</a-select-option>
                    </a-select>
                </div>
            </div>
        </div>
        <div class="data-panel" style="margin:0">
            <div class="data-panel-header" style="border-bottom:0; padding:10px 0 0 0;">
                <h2>{{$t('fixed.realtime.conversion.inConversion')}}</h2>
                <div class="extra">
                    <a-date-picker :placeholder="$t('common.selectDate')" v-model="date" :allowClear="false"/>
                </div>
            </div>
            <div class="data-panel-content fixed-data-panel-content">
                <transform-chart :datas="udidconversion_date_data" :height="300" style="margin-bottom:-50px"/>
            </div>
        </div>
        <div class="data-panel" style="margin:0">
            <div class="data-panel-header" style="border-bottom:0; border-top:1px dashed #ddd; padding:10px 0 0 0;">
                <h2>{{$t('fixed.realtime.conversion.inConversion')}}</h2>
                <div class="extra">
                    <a-button @click="exportToExcel(`udidconversion_${ratio_type}_table`, `${$service.PROJ_CODE}-${$t('fixed.realtime.conversion.inConversion')}${ratio_type=='stage'? $t('fixed.realtime.conversion.stage') :$t('fixed.realtime.conversion.overall')}-${date.format('YYYY-MM-DD')}-${app_channel_name}`)" :title="$t('common.download')"><a-icon type="download"/></a-button>
                    <a-button @click="copy(`udidconversion_${ratio_type}_table`)" id="copy-btn" style="margin:0 16px 0 8px;" :title="$t('common.copy')"><a-icon type="copy"/></a-button>
                    <a-radio-group v-model="ratio_type">
                        <a-radio-button value="whole">{{$t('fixed.realtime.conversion.overall')}}</a-radio-button>
                        <a-radio-button value="stage">{{$t('fixed.realtime.conversion.stage')}}</a-radio-button>
                    </a-radio-group>
                </div>
            </div>
            <div class="data-panel-content fixed-data-panel-content">
                <transform-data-table :selected="date?date.format('YYYY-MM-DD'):null" :fields="ratio_type=='whole'?whole_fields:stage_fields" :datas="data" :ref="`udidconversion_${ratio_type}_table`" @changeFilter="changeUdidConversionDate" :init="init"/>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment"

import TransformChart from '@/components/common/chart/transform_chart.vue'
import TransformDataTable from '@/components/common/datatable/udidconversion_datatable.vue'
import {datatableMixin} from '@/components/common/datatable/datatableMixin.js'

export default {
    name: 'udidPanel',
    mixins: [datatableMixin],
    inject: ['today', 'yesterday', 'ranges'],
    components: {
        TransformChart,
        TransformDataTable,
    },
    props: {
        // 数据接口
        api: {
            type: String,
        },
        // 标题
        title: {
            type: String,
            default: "数据展示",
        },
    },    
    data() {
        return {
            api: 'realtime_udidconversion',
            app_channels: [],
            orders:[],
            date: null,
            app_channel: '-127',
            ratio_type: 'whole',
            init: false,
            whole_fields: [
                {id:'dt', title: this.$t("common.date"), width:'16.6%'}, 
                {id: 'cnt1', title:'启动APP设备数', width:'16.6%', suffix:'%'},
                {id: 'whole_ratio2', title:'到达登陆界面', width:'16.6%', suffix:'%'},
                {id: 'whole_ratio3', title:'账号认证', width:'16.6%', suffix:'%'},
                {id: 'whole_ratio4', title:'到达游戏界面', width:'16.6%', suffix:'%'},
                {id: 'whole_ratio5', title:'进入游戏', width:'16.6%', suffix:'%'},
            ],
            stage_fields: [
                {id:'dt', title: this.$t("common.date"), width:'20%'}, 
                {id: 'cnt1', title:'启动APP设备数', width:'16.6%'},
                {id: 'stage_ratio2', title:'到达登陆界面', width:'16.6%', suffix:'%'},
                {id: 'stage_ratio3', title:'账号认证', width:'16.6%', suffix:'%'},
                {id: 'stage_ratio4', title:'到达游戏界面', width:'16.6%', suffix:'%'},
                {id: 'stage_ratio5', title:'进入游戏', width:'16.6%', suffix:'%'},
            ],
            data: [],
            dates: [],
        }
    },
    watch: {
        // 设备转化率选择渠道
        app_channel(newV) {
            this.getUdidConversion()
        },
        // 设备转化率选择时间
        date(newV) {
            if(newV && this.dates.indexOf(newV.format('YYYY-MM-DD'))<0) {
                this.getUdidConversion()
            }
        }
    },
    computed: {
        app_channel_name() {
            if(this.app_channel === '-127') {
                return this.$t("fixed.realtime.conversion.allChannel")
            }
            let channel = _.find(this.app_channels, {'id':this.app_channel})
            if(channel) {
                return channel.name
            }
            return ''
        },
        udidconversion_date_data() {
            if(!this.date) {
                return []
            }

            let dt = _.find(this.data, {'dt':this.date.format('YYYY-MM-DD')})
            if(!dt) {
                return []
            }
            let data = []
            this.orders.forEach((o, index)=>{
                data.push({order:index+1, stage:o.stage_name, cnt:dt[`cnt${o.order}`], whole_ratio:dt[`whole_ratio${o.order}`], stage_ratio:dt[`stage_ratio${o.order}`]})
            })
            return data
        },
    },
    mounted() {
        this.initUdidConversion()
    },
    methods: {
        initUdidConversion() {
            this.getUdidConversionInfo()
            this.date = this.today
        },
         // 获取设备转化率初始信息
        getUdidConversionInfo() {
            this.$service.query_fixed_module(`${this.api}_info`).then((data)=>{
                this.app_channels = data.app_channel
                this.orders = data.order
                if(data.order.length==0) {
                    this.whole_fields = []
                    this.stage_fields = []
                }
                else {
                    let field_width = `${100.0/( 1+ data.order.length)}%`
                    let whole_fields = [{id:'dt', title: this.$t("common.date"), width:field_width}, ]
                    let stage_fields = [{id:'dt', title: this.$t("common.date"), width:field_width}, ]
                    data.order.forEach((o, index)=>{
                        if(index==0) {
                            whole_fields.push({id: `cnt${o.order}`, title:o.stage_name, width:field_width},)
                            stage_fields.push({id: `cnt${o.order}`, title:o.stage_name, width:field_width},)
                        }
                        else {
                            whole_fields.push({id: `whole_ratio${o.order}`, title:o.stage_name, width:field_width, suffix:'%'},)
                            stage_fields.push({id: `stage_ratio${o.order}`, title:o.stage_name, width:field_width, suffix:'%'},)
                        }
                    })
                    this.whole_fields = whole_fields
                    this.stage_fields = stage_fields
                }
            })
        },
        // 获取设备转化率数据
        getUdidConversion() {
            this.$service.query_fixed_module(this.api, {app_channel:this.app_channel, dt:new moment(this.date).format('YYYY-MM-DD')}).then((data)=>{
                this.data = data
                let dates = []
                data.forEach((row)=>{
                    dates.push(row.dt)
                })
                this.dates = dates

                this.init = true
                this.$nextTick(()=>{
                    this.init = false
                })
                this.loading = false
            }).catch((errors)=>{
                this.loading = false
            })
        },
        changeUdidConversionDate(dt) {
            this.date = moment(dt)
        },
    }
}
</script>